import { Component } from '@angular/core';

@Component({
    selector: 'app-subscription-trial-card',
    templateUrl: './subscription-trial-card.component.html',
    standalone: false
})

export class TrialCardComponent {

}
